import { useAspectRatio } from "../../hooks/use-aspect-ratio";
import type { ItemWithCheckoutProduct } from "../../hooks/use-items-with-checkout";
import { FeedItem } from "./FeedItem";

export interface FeedGridProps {
  items: ItemWithCheckoutProduct[];
}

export function FeedGrid({ items }: FeedGridProps) {
  const aspectRatios = items.flatMap((item) =>
    item.media.aspect_ratio ? [item.media.aspect_ratio] : [],
  );

  const aspectRatio = useAspectRatio(aspectRatios);

  return (
    <div className="lookbook--feed--grid">
      {items.map((item) => {
        return <FeedItem key={item.id} item={item} aspectRatio={aspectRatio} />;
      })}
    </div>
  );
}
